import { useLocalStorageValue } from "@react-hookz/web";
import { useEffect } from "react";
import { useMatch } from "react-router";
import { useAccountId } from "../generic/hooks/use-account-id";

import type { UUID } from "../../utils/uuid";
import type { FC } from "react";

type ListenVisits = Partial<Record<UUID, string>>;

const useListenVisitsValue = () =>
  useLocalStorageValue<ListenVisits>("listen-last-visits", { defaultValue: {} });

export function useLastListenVisit(): string | undefined {
  const accountId = useAccountId();
  const { value } = useListenVisitsValue();

  return accountId ? value?.[accountId] : undefined;
}

export const RecordListenVisit: FC = () => {
  const visiting = Boolean(useMatch("/listen"));
  const accountId = useAccountId();
  const { set } = useListenVisitsValue();

  useEffect(() => {
    if (visiting && accountId)
      set((visits) => ({ ...visits, [accountId]: new Date().toISOString() }));
  }, [visiting, accountId, set]);

  return null;
};
